import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { TechniqueDto } from '../../shared/remote-services/dtos/technique.dto'

@Injectable()
export class TechniqueService {
  private http = inject(HttpClient)

  public getAll(): Observable<TechniqueDto[]> {
    return this.http.get<TechniqueDto[]>(`jobsite/techniques`)
  }
}
